export default '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048.55 1024"><path d="M512.271 0 0 512.271 512.271 1024h1536.271V0z"></path></svg>';